export default __webpack_public_path__ + "static/media/trip-to-nowhere.1bffa859.jpg";